let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lkVN1")).then(() => parcelRequire('8wpGk'));